module.exports = __webpack_public_path__ + "static/media/ill_vaccination.20843e7f.svg";